// src/mocks/handlers/dashboard/latestCollections.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import {
  ILatestCollection,
  ILatestCollectionsResponse,
} from '@/domains/dashboard/latestCollections/latestCollections.types';
import latestCollectionsData from '@/mocks/data/dashboard_latestCollections.json';
import { IRequestLatestCollections } from '@/domains/dashboard/latestCollections/latestCollections.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const latestCollectionsHandler = rest.get<
  ILatestCollectionsResponse,
  IRequestLatestCollections
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.DASHBOARD_LATEST_COLLECTIONS}`,
  (req, res, ctx) => {
    const { customer_uuid } = req.params;

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    // Filter the data based on the customer_uuid
    const customerCollections = latestCollectionsData.find(
      (entry) => entry.customer === customer_uuid,
    );

    const collections: ILatestCollection[] = customerCollections
      ? customerCollections.results.slice(0, 10)
      : [];

    return res(ctx.status(200), ctx.json({ results: collections }));
  },
);
